import React from 'react'
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";
import PublicPageShell from "../components/PublicPageShell";

export const AboutUs = () => {
  const { pageHeader, isLoading } = usePageHeaderByKey("about-us");

  if (isLoading) {
    return (
      <div className="flex h-screen justify-center items-center">
        <i className="pi pi-spin pi-spinner text-red-700" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  return (
    <PublicPageShell>
      <div className="flex flex-col justify-center w-full">
        {pageHeader?.h1 && (
          <h1 className="text-2xl mb-4 text-center font-bold text-black uppercase">
            {pageHeader.h1}
          </h1>
        )}
        {pageHeader?.tagline && (
          <p className="mb-4 text-gray-700 md:text-sm leading-relaxed text-center">
            {pageHeader.tagline}
          </p>
        )}
        {pageHeader?.content ? (
          <div 
            className="text-gray-700 leading-relaxed mb-4 md:text-sm"
            dangerouslySetInnerHTML={{ __html: pageHeader.content }}
          />
        ) : (
          <div className='flex items-center justify-center'>COMING SOON...</div>
        )}
      </div>
    </PublicPageShell>
  )
}
